import { render, staticRenderFns } from "./VirtualServerVirtualInternetAccess.vue?vue&type=template&id=292833b9&"
import script from "./VirtualServerVirtualInternetAccess.vue?vue&type=script&lang=js&"
export * from "./VirtualServerVirtualInternetAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports